import { render, staticRenderFns } from "./new_addon.vue?vue&type=template&id=51f69453&scoped=true"
import script from "./new_addon.vue?vue&type=script&lang=js"
export * from "./new_addon.vue?vue&type=script&lang=js"
import style0 from "./new_addon.vue?vue&type=style&index=0&id=51f69453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f69453",
  null
  
)

export default component.exports